<template>
  <div id="app">
   <!-- <img src="./assets/logo.png"> -->
   <navbar></navbar>
   <!--
    <h1>{{ msg }}</h1>
    <p>
      <router-link to="/">Home</router-link>
      <router-link to="/about">About</router-link>
      <router-link to="/contact">Contact</router-link>
    </p>
    -->
        <router-view></router-view>
    <footerbar></footerbar>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Footerbar from './components/Footerbar.vue'
import Homepage from './components/Homepage.vue'
export default {
  name: 'app',
  components: {
    Navbar,
    Footerbar,
    Homepage
  },
  data () {
    return {
      msg: 'App'
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?22cd38ba